import { render, staticRenderFns } from "./list-detail-panel.vue?vue&type=template&id=081620e4&scoped=true&"
import script from "./list-detail-panel.vue?vue&type=script&lang=ts&"
export * from "./list-detail-panel.vue?vue&type=script&lang=ts&"
import style0 from "./list-detail-panel.vue?vue&type=style&index=0&id=081620e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081620e4",
  null
  
)

export default component.exports